/**
 * Проверяет, что значение является валидным объектом Date (не Invalid Date).
 * @param {*} date - Проверяемое значение.
 * @returns {boolean} true, если это валидная дата.
 */
const isValidDate = (date) => date instanceof Date && !Number.isNaN(date.getTime());
export default isValidDate;
